exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.el-card[data-v-701692ae] {\r\n  padding: 20px;\n}\n.float-right[data-v-701692ae] {\r\n  float: right;\n}\r\n", ""]);

